<template>
  <PageHeader :title="$t('ui.entities.group')">
    <template #right></template>
  </PageHeader>
</template>

<script setup>
import PageHeader from '@/components/page/PageHeader.vue'
</script>

<style></style>
